import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-wavesquare",
  "use": "icon-th-wavesquare-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-wavesquare\">\n<path d=\"M30 16V23C30 23.2652 29.8946 23.5196 29.7071 23.7071C29.5196 23.8946 29.2652 24 29 24H16C15.7348 24 15.4804 23.8946 15.2929 23.7071C15.1054 23.5196 15 23.2652 15 23V10H4V16C4 16.2652 3.89464 16.5196 3.70711 16.7071C3.51957 16.8946 3.26522 17 3 17C2.73478 17 2.48043 16.8946 2.29289 16.7071C2.10536 16.5196 2 16.2652 2 16V9C2 8.73478 2.10536 8.48043 2.29289 8.29289C2.48043 8.10536 2.73478 8 3 8H16C16.2652 8 16.5196 8.10536 16.7071 8.29289C16.8946 8.48043 17 8.73478 17 9V22H28V16C28 15.7348 28.1054 15.4804 28.2929 15.2929C28.4804 15.1054 28.7348 15 29 15C29.2652 15 29.5196 15.1054 29.7071 15.2929C29.8946 15.4804 30 15.7348 30 16Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-wavesquare.svg
// module id = Q59Z
// module chunks = 84